import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const ibanVerificationSelector = ({ ibanVerification }: ReducerState) => ibanVerification;
export const ibanVerificationLoadingSelector = createSelector(
  ibanVerificationSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
